
// src/web/components/chat-message-form.jsx

import React from 'react'
import connect from '../../connects/chat-message-form'
import {
  Button,
} from 'react-toolbox/lib/button'
import ProgressBar from 'react-toolbox/lib/progress_bar'
import FileUploadButton from './file-upload-button.jsx'
import RichTextEditor from './rich-text-editor.jsx'
import diaryFormButtonTheme from './themes/diary-form-button.css'
import MessageStorage from '../../helpers/message-storage'
import DiaryUrlLinks from './diary-url-links.jsx'
import ConfirmGoogleLogin from './confirm-google-login.jsx'

const UNSUBMIT_MESSAGE = 'gambaApp.unSubmitMessage'
class ChatMessageForm extends React.Component {
  uploadFiles = (files)=> this.props.uploadFiles(this.props, files)
  showStampPalette = ()=> this.props.showStampPalette((code)=> this.props.postStampMessage(code), true)
  onChangeEditor = (event)=> {
    // Check if event and event.nativeEvent exist
    if (event && event.nativeEvent && event.nativeEvent.isComposing)  {
      return // Prevent premature updates during IME composition
    }
    this.props.onChangeEditor(this.props)
  }
  cancelMessage = ()=> {
    this.props.cancelMessage(this.props)
    MessageStorage.getItem(UNSUBMIT_MESSAGE).then((canselMessage) => {
      let canselMessages = JSON.parse(canselMessage || '[]')
      let canselFilter = _.filter(canselMessages, (_canselMessage) => _canselMessage.id !== this.props.chatRoom.chat_room_id)
    MessageStorage.setItem(UNSUBMIT_MESSAGE, JSON.stringify(canselFilter))
    }).catch(()=> undefined)
  }
  onEditorInitialized = (handlers) => {
    this.props.updateUI({ handlers })
    if (this.unsubmitMessage) {
      setTimeout(() => { handlers.insertValue(this.unsubmitMessage); this.unsubmitMessage = undefined }, 0)
    }
  }
  postChatMessage = ()=> {
    this.props.postChatMessage(this.props)
    MessageStorage.getItem(UNSUBMIT_MESSAGE).then((submitMessage) => {
      let submitMessages = JSON.parse(submitMessage || '[]')
      let submitFilter = _.filter(submitMessages, (_submitMessage) => _submitMessage.id !== this.props.chatRoom.chat_room_id)
      MessageStorage.setItem(UNSUBMIT_MESSAGE, JSON.stringify(submitFilter))
    }).catch(()=> undefined)
  }
  onAddLink = (link)=> this.props.onAddLink(this.props, link)
  onDeleteLink = (link)=> this.props.onDeleteLink(this.props, link)
  onCancelConfirmGapi = ()=> this.props.onCancelConfirmGapi(this.props)
  onSuccessConfirmGapi = ()=> this.props.onSuccessConfirmGapi(this.props)
  onFocus = ()=> this.props.updateUI({ hasFocus: true })
  componentDidMount() {
    MessageStorage.getItem(UNSUBMIT_MESSAGE).then((_unsubmitMessage)=> {
      let unSubmitMessage = JSON.parse(_unsubmitMessage)
      let unSubmitIndex = _.findIndex(unSubmitMessage, (_unSubmitMessage) => _unSubmitMessage.id == this.props.chatRoom.chat_room_id)
      if (this.props.ui.handlers)
        this.props.ui.handlers.insertValue(unSubmitMessage[unSubmitIndex].message)
      else
        this.unsubmitMessage = unSubmitMessage[unSubmitIndex].message
    }).catch(()=> undefined)
  }
  render() {
  const {
    t,
    ui,
    isPosting,
    chatRoom,
    postChatMessage,
    postStampMessage,
    cancelMessage,
    onChangeMessage,
    uploadFiles,
    uploadedFiles,
    uploadedVideos,
    showStampPalette,
    updateUI,
    onChangeEditor,
    showGoogleDoc,
    showGambaUrl,
    urlInfo
  } = this.props

  return (
    <div style={{}}>
      {uploadedFiles && _.map(uploadedFiles, (file, key)=> 
        file && file.isUploading &&
          <ProgressBar key={key} multicolor
              mode={file.total && 'determinate' || 'indeterminate'}
              value={file.total && file.loaded && file.loaded * 100 / file.total} />
      )}
      {uploadedVideos && _.map(uploadedVideos, (video, key)=> 
        video && video.isUploading &&
          <ProgressBar key={key} multicolor
              mode={video.total && 'determinate' || 'indeterminate'}
              value={video.total && video.loaded && video.loaded * 100 / video.total} />
      )}
      <RichTextEditor compact hasFocus noToolbar 
          chatMessage={true}
          onDrop={this.uploadFiles}
          onChange={this.onChangeEditor}
          onCompositionEnd={this.onChangeEditor} // Handle IME finalized input
          showGoogleDoc={showGoogleDoc}
          showGambaUrl={showGambaUrl}
          onFocus={this.onFocus}
          onAddLink={this.onAddLink}
          onDeleteLink={this.onDeleteLink}
          onEditorInitialized={this.onEditorInitialized}
          placeholder={t('label:メッセージを入力してください')} />
      <DiaryUrlLinks urlLinks={ui.urlLinks} onDeleteLink={this.onDeleteLink} isChat={true}/>
      <div style={{ display: 'flex' }}>
        <Button raised primary
            theme={diaryFormButtonTheme}
            disabled={isPosting || urlInfo && urlInfo.isFetching}
            icon='send'
            onClick={this.postChatMessage}
            label={t('label:送信')}
            style={{ minWidth: 100 }}/>
        <FileUploadButton raised
            theme={diaryFormButtonTheme}
            icon='add_a_photo'
            onChange={this.uploadFiles}
            label={t('label:添付')} />
        <Button raised
            theme={diaryFormButtonTheme}
            icon='tag_faces'
            onClick={this.showStampPalette}
            label={t('label:スタンプ')} />
        <Button
            theme={diaryFormButtonTheme}
            style={{ marginLeft: 'auto'}}
            icon='close'
            onClick={this.cancelMessage}
            label={t('label:取り消し')} />
      </div>
    </div>
  )
  }
}

export const RawChatMessageForm  = ChatMessageForm
export default connect(ChatMessageForm)



// WEBPACK FOOTER //
// ./src/web/components/chat-message-form.jsx